// AUTO-GENERATED FILE. DO NOT EDIT MANUALLY.
// Generated from CHANGELOG.md by scripts/sync-changelog-to-ui.mjs
// Keep CHANGELOG.md as the single source of truth.

export type ChangelogEntry = {
  version: string;
  date: string; // YYYY-MM-DD
  changes: string[];
};

export const CHANGELOG: ChangelogEntry[] = [
  {
    "version": "0.0.0",
    "date": "2026-04-16",
    "changes": [
      "Первый релиз."
    ]
  }
];
